import { Controller } from "stimulus"
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = [ "radioOption" ]

  connect () {
    let inputs = document.getElementsByClassName('se-input-ap')
    let alturaPisoSection = document.getElementById('altura-piso-section')

    this.radioOptionTargets.forEach(el => {
      if (el.checked) {
        if (el.value == 'false') {
          Array.from(inputs).forEach(el => {
            el.classList.remove('d-none')
          })
          alturaPisoSection.classList.remove('d-none')
        } else {
          Array.from(inputs).forEach(el => {
            el.classList.add('d-none')
          })
          alturaPisoSection.classList.add('d-none')
        }
      }
    });
  }

  fetchDiagram () {
    let ajustes = []
    let buqueAjustesSection = document.getElementById('ajuste-buque-section').parentElement.querySelectorAll('input[type="checkbox"]')
    buqueAjustesSection.forEach(el => {
      if (el.checked) {
        ajustes.push(el.value)
      }
    })
    let showPisoAltura = this.radioOptionTargets.find(el => el.checked && el.value == 'false') ? true : false
    Rails.ajax({
      url: './fetch_diagram',
      type: 'GET',
      data: `ajustes=${ajustes};showPisoAltura=${showPisoAltura}`
    })
  }

  toggleAlturaPiso (event) {
    let inputs = document.getElementsByClassName('se-input-ap')
    let alturaPisoSection = document.getElementById('altura-piso-section')

    if (event.target.value == 'false') {
      alturaPisoSection.classList.remove('d-none')
      Array.from(inputs).forEach(el => {
        el.classList.remove('d-none')
      })
    } else {
      alturaPisoSection.classList.add('d-none')
      Array.from(inputs).forEach(el => {
        el.classList.add('d-none')
      })
    }
    this.fetchDiagram()
  }
}
